module.exports = __webpack_public_path__ + "img/c05_unitstartechbellumromanum_Normal_ua.ff151021.webp";